import makeStyles from '@mui/styles/makeStyles';
import { Box, Typography } from '@mui/material';
import React from 'react';

type DataFieldBoxProps = {
    label: string;
    count?: number;
    children: React.ReactNode;
};

const useStyles = makeStyles((theme) => ({
    root: {
        border: '1px solid #e9ecef',
        padding: theme.spacing(2),
        backgroundColor: '#fafbfc',
        borderRadius: theme.spacing(1),
    },
    label: {
        fontSize: 12,
        color: '#6c757d',
        fontWeight: 600,
        textTransform: 'uppercase',
        letterSpacing: 0.5,
        marginBottom: theme.spacing(1),
    },
}));

const DataFieldBox: React.FC<DataFieldBoxProps> = ({ label, count, children }) => {
    const classes = useStyles();
    return (
        <Box className={classes.root}>
            <Typography className={classes.label}>
                {count !== undefined ? `${label} (${count})` : label}
            </Typography>
            {children}
        </Box>
    );
};

export default DataFieldBox;
